var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-slicer-bar",class:_vm.$$FormData.align,style:({
    backgroundColor: _vm.$$FormData.background_color,
    height: _vm.$$FormData.height + 'px',
    '--h-padding': _vm.$$FormData.h_padding + 'px'
  })},[_c('div',{staticClass:"title-slicer-bar__inner",style:({'--icon-img': `url(${_vm.$$FormData.slicer_icon.src})`})},[_c('h3',{staticClass:"title-slicer-bar__text",style:({color: _vm.$$FormData.title_font_color})},[_vm._v(_vm._s(_vm.$$FormData.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }